export const COMMENT = `{
  person_id
  owner
  message
  createdAt
}`
